import * as React from 'react'
const SvgIcoSpotEx = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlSpace='preserve'
    viewBox='0 0 200 200'
    {...props}
  >
    <style>
      {
        '.ICO_SpotEX_N_svg__st0{display:none}.ICO_SpotEX_N_svg__st1{display:inline}.ICO_SpotEX_N_svg__st2{fill:#7984ba}.ICO_SpotEX_N_svg__st3,.ICO_SpotEX_N_svg__st4{fill-rule:evenodd;clip-rule:evenodd}.ICO_SpotEX_N_svg__st4{fill:#7984ba}'
      }
    </style>
    <g id='ICO_SpotEX_N_svg__Calque_12'>
      <path d='M124.09 91.04c0 4.12-4.12 8.24-8.24 8.24h-2.75c-4.12 0-8.24-4.12-8.24-8.24V82.8h-2.75v8.24c0 5.51 5.51 11 11 11v5.51h-8.24v2.75h19.26v-2.75h-8.24v-5.51c5.51 0 11-5.51 11-11V82.8h-2.75v8.24z' />
      <path d='M115.83 96.54c3.04 0 5.51-2.47 5.51-5.47V71.78c0-3.02-2.45-5.47-5.51-5.47h-2.72c-3.04 0-5.51 2.47-5.51 5.47v19.29c0 3.02 2.45 5.47 5.51 5.47zM82.36 84.64H93.8v3.76H82.36zM77.55 95.69H93.8v3.76H77.55zM93.81 110.22H73.64v-3.76h20.17' />
    </g>
  </svg>
)
export default SvgIcoSpotEx

